export enum PictureKeys {
  DESKTOP = 'desktop',
  DESKTOP_2X = 'desktop2x',
  DESKTOP_2X_WEBP = 'desktop2xWebp',
  DESKTOP_WEBP = 'desktopWebp',
  MOBILE = 'mobile',
  MOBILE_2X = 'mobile2x',
  MOBILE_2X_WEBP = 'mobile2xWebp',
  MOBILE_WEBP = 'mobileWebp',
  TABLET = 'tablet',
  TABLET_2X = 'tablet2x',
  TABLET_2X_WEBP = 'tablet2xWebp',
  TABLET_WEBP = 'tabletWebp',
}

export interface IPicture {
  [PictureKeys.DESKTOP_WEBP]: string;
  [PictureKeys.DESKTOP]: string;
  [PictureKeys.DESKTOP_2X_WEBP]: string;
  [PictureKeys.DESKTOP_2X]: string;
  [PictureKeys.MOBILE_WEBP]: string;
  [PictureKeys.MOBILE]: string;
  [PictureKeys.MOBILE_2X_WEBP]: string;
  [PictureKeys.MOBILE_2X]: string;
  [PictureKeys.TABLET_WEBP]: string;
  [PictureKeys.TABLET]: string;
  [PictureKeys.TABLET_2X_WEBP]: string;
  [PictureKeys.TABLET_2X]: string;
  alt: string;
}
